/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["pusnaktī","pusd.","no rīta","pēcpusd.","vakarā","naktī"],u,["pusnaktī","pusdienlaikā","no rīta","pēcpusdienā","vakarā","naktī"]],[["pusnakts","pusd.","rīts","pēcpusd.","vakars","nakts"],u,["pusnakts","pusdienlaiks","rīts","pēcpusdiena","vakars","nakts"]],["00:00","12:00",["06:00","12:00"],["12:00","18:00"],["18:00","23:00"],["23:00","06:00"]]];
